import ModuleTypes from "website_script/constants/ModuleTypes"
import type { Settings } from "website_script/types/settings"

export const getTestDriveModuleType = (
  settings: Settings
): ModuleTypes.IMPROVED_BOOK_TEST_DRIVE | ModuleTypes.BOOK_TEST_DRIVE => {
  return settings.enableNewTestDriveModule
    ? ModuleTypes.IMPROVED_BOOK_TEST_DRIVE
    : ModuleTypes.BOOK_TEST_DRIVE
}
